export const APP_DOC_ATTACHMENT_DEFS = [
  { key: 'mynumber', label: 'マイナンバーカードの写し（番号の記載がない面・表面）' },
  { key: 'mynumberBack', label: 'マイナンバーカードの写し（番号の記載がない面・裏面）' },
  { key: 'license', label: '運転免許証の写し（表面）' },
  { key: 'licenseBack', label: '運転免許証の写し（裏面）' },
  { key: 'residenceCard', label: '在留カードの写し（表面）' },
  { key: 'residenceCardBack', label: '在留カードの写し（裏面）' },
  { key: 'disabilityBook', label: '障害者手帳の写し（表面）' },
  { key: 'disabilityBookBack', label: '障害者手帳の写し（裏面）' },
  { key: 'passport', label: 'パスポートの写し' },
  { key: 'kosekiAll', label: '全世帯員の戸籍謄本の写し（全部事項証明書）' },
  { key: 'foreignResidentJuminhyo', label: '全世帯員の住民票の写し（外国人の場合）' },
  { key: 'bankBookOrCard', label: '振込先口座が確認できる預貯金通帳の写し、またはキャッシュカードの写し' },
  { key: 'consent', label: '同意書（追加給付に当たって必要な調査に係る同意）' },
  { key: 'kosekiAppendix', label: '戸籍謄本の附票の写し（当時の居所を記載できない場合）' },
  { key: 'proxyDocuments', label: '代理人関係書類（委任状・身分確認書類・本人との関係を証する書類）' },
  // 以下は旧データ互換のため定義は残すが、添付一覧には表示しない（juminhyoAll は外国人用に統合、保護受給証明書は戸籍謄本・住民票の注記に統合）
  { key: 'juminhyoAll', label: '全世帯員の住民票の写し' },
  { key: 'protectionCertificate', label: '保護受給証明書（保護受給中は戸籍謄本・住民票の代替として可）' },
];

/** 添付書類の表示構成（version2 準拠）。表面/裏面は1つの見出しにまとめる。先頭5件は本人確認書類（いずれか1点）。 */
export const APP_DOC_ATTACHMENT_GROUPS: {
  label: string;
  idDoc?: boolean;
  note?: string;
  parts: { key: string; label?: string }[];
}[] = [
  { label: 'マイナンバーカードの写し（番号の記載がない面）', idDoc: true, parts: [{ key: 'mynumber', label: '表面' }, { key: 'mynumberBack', label: '裏面' }] },
  { label: '運転免許証の写し', idDoc: true, parts: [{ key: 'license', label: '表面' }, { key: 'licenseBack', label: '裏面' }] },
  { label: '在留カードの写し', idDoc: true, parts: [{ key: 'residenceCard', label: '表面' }, { key: 'residenceCardBack', label: '裏面' }] },
  { label: '障害者手帳の写し', idDoc: true, parts: [{ key: 'disabilityBook', label: '表面' }, { key: 'disabilityBookBack', label: '裏面' }] },
  { label: 'パスポートの写し', idDoc: true, parts: [{ key: 'passport' }] },
  { label: '全世帯員の戸籍謄本の写し（全部事項証明書）', note: '※ 保護受給中の場合は、戸籍謄本に代えて保護受給証明書によることも可', parts: [{ key: 'kosekiAll' }] },
  { label: '全世帯員の住民票の写し（外国人の場合）', note: '※ 保護受給中の場合は、住民票に代えて保護受給証明書によることも可', parts: [{ key: 'foreignResidentJuminhyo' }] },
  { label: '振込先口座が確認できる預貯金通帳の写し、またはキャッシュカードの写し', parts: [{ key: 'bankBookOrCard' }] },
  { label: '同意書（追加給付に当たって必要な調査に係る同意）', parts: [{ key: 'consent' }] },
  { label: '戸籍謄本の附票の写し（当時の居所を記載できない場合）', parts: [{ key: 'kosekiAppendix' }] },
  { label: '代理人関係書類（委任状・身分確認書類・本人との関係を証する書類）', parts: [{ key: 'proxyDocuments' }] },
];

export const MULTI_FILE_ATTACHMENT_KEYS = new Set([
  'passport',
  'kosekiAll',
  'juminhyoAll',
  'foreignResidentJuminhyo',
  'protectionCertificate',
  'bankBookOrCard',
  'kosekiAppendix',
  'proxyDocuments',
]);

/** 旧データ／旧キーからの別名解決（version2 でキー名が整理された分の互換維持）。 */
export const APP_DOC_ATTACHMENT_KEY_ALIASES: Record<string, string> = {
  mynumber_front: 'mynumber',
  mynumber_back: 'mynumberBack',
  license_front: 'license',
  license_back: 'licenseBack',
  residenceCard_front: 'residenceCard',
  residenceCard_back: 'residenceCardBack',
  disabilityBook_front: 'disabilityBook',
  disabilityBook_back: 'disabilityBookBack',
  kosekiFupyo: 'kosekiAppendix',
  proxyDocs: 'proxyDocuments',
  juminhyoForeign: 'foreignResidentJuminhyo',
};

export const APP_DOC_ADDON_TYPES = [
  '入院患者日用品費',
  '救護施設等基準生活費・介護施設入所者基本生活費',
  '障害者加算',
  '母子加算',
  '妊産婦加算',
  '在宅患者加算',
  '放射線障害者加算',
  '未成年者控除（20歳未満控除）',
];

/**
 * 世帯主との続柄の選択肢。先頭の「世帯主本人」は1行目（世帯主）用。
 * 公開申出フォーム（citizen form）および DB 保存値と統一するため「世帯主本人」を正規トークンとする
 * （旧データの「本人」は読み込み時に「世帯主本人」へ正規化する）。
 */
export const APP_DOC_RELATION_OPTIONS = [
  '世帯主本人', '配偶者', '子', '父', '母', '孫', '祖父', '祖母',
  '兄', '弟', '姉', '妹', '甥', '姪', 'ひ孫', 'その他',
];

/** 加算等の種類ごとの付帯情報（追加入力欄ラベル・補足・挙証資料の例）。version2 と同内容。 */
export const APP_DOC_ADDON_TYPE_META: Record<string, { extraLabel: string; note: string; evidence: string }> = {
  '入院患者日用品費': { extraLabel: '医療機関名', note: '当時、1か月をこえる入院期間がある場合は入院期間を記載', evidence: '特に定めはありません（挙証資料の提出は不要です）。' },
  '救護施設等基準生活費・介護施設入所者基本生活費': { extraLabel: '施設名', note: '救護施設・更生施設・介護老人福祉施設・児童養護施設等に入所していた期間', evidence: '特に定めはありません（挙証資料の提出は不要です）。' },
  '障害者加算': { extraLabel: '', note: '', evidence: '身体障害者手帳、国民年金証書、特別児童扶養手当受給証明書、福祉手当認定通知書 等。又は障害者に関する保護費の決定通知書' },
  '母子加算': { extraLabel: '', note: '', evidence: '児童扶養手当の証書・通知書、または母子家庭の決定に関する保護決定通知書' },
  '妊産婦加算': { extraLabel: '', note: '', evidence: '母子健康手帳、または妊産婦加算の決定に関する保護決定通知書' },
  '在宅患者加算': { extraLabel: '', note: '', evidence: '結核治療に係る書類、在宅患者加算の決定に関する保護決定通知書' },
  '放射線障害者加算': { extraLabel: '', note: '', evidence: '被爆者健康手帳、原爆症認定に係る書類、放射線障害者加算の決定に関する保護決定通知書' },
  '未成年者控除（20歳未満控除）': { extraLabel: '就労先', note: '当時、就労していた未成年者', evidence: '20歳未満の就労に係る給与明細、及び20歳未満控除の認定に係る保護決定通知書' },
};

/** 旧カテゴリ文字列（救護/介護の分離・「障碍」表記）を現行の統合・正規表記へ寄せる。旧データ互換。 */
export const APP_DOC_ADDON_CATEGORY_ALIASES: Record<string, string> = {
  '救護施設等基準生活費': '救護施設等基準生活費・介護施設入所者基本生活費',
  '介護施設入所者基本生活費等': '救護施設等基準生活費・介護施設入所者基本生活費',
  '障碍者加算': '障害者加算',
};

export const normalizeAddonCategory = (category?: string): string => {
  const c = String(category ?? '').trim();
  return APP_DOC_ADDON_CATEGORY_ALIASES[c] || c;
};

export const appDocAddonMeta = (category: string) =>
  APP_DOC_ADDON_TYPE_META[normalizeAddonCategory(category)] || { extraLabel: '', note: '', evidence: '' };

/** 加算等の期間表示（YYYY-MM ～ YYYY-MM）。 */
export const formatAddonPeriodLabel = (start?: string, end?: string) => {
  const s = String(start || '').trim();
  const e = String(end || '').trim();
  if (!s && !e) return '';
  return `${s || '—'} ～ ${e || '—'}`;
};

export const ADDON_EVIDENCE_KEY = 'addonEvidence';
export const ADDON_EVIDENCE_KEY_PREFIX = 'addonEvidence_';

export const isAddonEvidenceAttachmentKey = (key: string) => {
  if (key === ADDON_EVIDENCE_KEY) return true;
  if (!key.startsWith(ADDON_EVIDENCE_KEY_PREFIX)) return false;
  return /^\d+$/.test(key.slice(ADDON_EVIDENCE_KEY_PREFIX.length));
};

// 加算挙証（addonEvidence_<数字>）も多ファイル添付。プロトタイプ（給付管理ツール_version2）に合わせ、
// 1 行に複数の挙証資料を添付できるようにする（バックエンドの append 分岐と対応）。
export const isMultiFileAttachmentKey = (key: string) =>
  MULTI_FILE_ATTACHMENT_KEYS.has(key) || isAddonEvidenceAttachmentKey(key);

export interface AttachmentFileMeta {
  fileName: string;
  uploadedAt: string;
  contentType: string;
  size?: number;
}

export interface AttachmentMeta extends AttachmentFileMeta {
  files?: AttachmentFileMeta[];
}

const normalizeAttachmentFileMeta = (x: unknown): AttachmentFileMeta | null => {
  if (!x || typeof x !== 'object') return null;
  const obj = x as Record<string, unknown>;
  if (!obj.fileName || !String(obj.fileName).trim()) return null;
  return {
    fileName: String(obj.fileName).trim(),
    uploadedAt: obj.uploadedAt ? String(obj.uploadedAt) : '',
    contentType: obj.contentType ? String(obj.contentType) : '',
    size: obj.size != null ? Number(obj.size) : undefined,
  };
};

export const attachmentEntryFromFiles = (files: AttachmentFileMeta[]): AttachmentMeta | null => {
  const normalized = files
    .map((file) => normalizeAttachmentFileMeta(file))
    .filter((file): file is AttachmentFileMeta => Boolean(file));
  if (normalized.length === 0) return null;
  return {
    ...normalized[0],
    files: normalized,
  };
};

const normalizeAttachmentMeta = (x: unknown): AttachmentMeta | null => {
  if (!x || typeof x !== 'object') return null;
  const obj = x as Record<string, unknown>;
  if (Array.isArray(obj.files)) {
    return attachmentEntryFromFiles(obj.files);
  }
  const single = normalizeAttachmentFileMeta(x);
  return single ? attachmentEntryFromFiles([single]) : null;
};

export const attachmentFilesOf = (attachment: AttachmentMeta | null | undefined): AttachmentFileMeta[] => {
  if (!attachment) return [];
  if (Array.isArray(attachment.files) && attachment.files.length > 0) {
    return attachment.files
      .map((file) => normalizeAttachmentFileMeta(file))
      .filter((file): file is AttachmentFileMeta => Boolean(file));
  }
  return attachment.fileName ? [attachment] : [];
};

export const emptyAppDocAttachments = (): Record<string, AttachmentMeta | null> => {
  const o: Record<string, AttachmentMeta | null> = {};
  APP_DOC_ATTACHMENT_DEFS.forEach((d) => {
    o[d.key] = null;
  });
  return o;
};

export const mergeAppDocAttachments = (src: unknown): Record<string, AttachmentMeta | null> => {
  const base = emptyAppDocAttachments();
  if (!src || typeof src !== 'object') return base;
  const srcObj = src as Record<string, unknown>;
  APP_DOC_ATTACHMENT_DEFS.forEach((d) => {
    base[d.key] = normalizeAttachmentMeta(srcObj[d.key]);
  });
  Object.entries(APP_DOC_ATTACHMENT_KEY_ALIASES).forEach(([oldKey, newKey]) => {
    if (base[newKey]) return;
    base[newKey] = normalizeAttachmentMeta(srcObj[oldKey]);
  });
  Object.entries(srcObj).forEach(([key, value]) => {
    if (!isAddonEvidenceAttachmentKey(key)) return;
    const meta = normalizeAttachmentMeta(value);
    if (meta) base[key] = meta;
  });
  return base;
};

/** 編集フォーム用：空ファイル名も保持（保存時は mergeAppDocAttachments で正規化） */
export const normalizeAttachmentsForForm = (src: unknown): Record<string, AttachmentMeta | null> => {
  const o: Record<string, AttachmentMeta | null> = {};
  const srcObj = (src && typeof src === 'object') ? (src as Record<string, unknown>) : null;
  APP_DOC_ATTACHMENT_DEFS.forEach((d) => {
    const x = srcObj && srcObj[d.key];
    if (!x || typeof x !== 'object') {
      o[d.key] = null;
    } else {
      const obj = x as Record<string, unknown>;
      if (Array.isArray(obj.files)) {
        o[d.key] = normalizeAttachmentMeta(obj);
      } else {
        o[d.key] = {
          fileName: obj.fileName != null ? String(obj.fileName) : '',
          uploadedAt: obj.uploadedAt != null ? String(obj.uploadedAt) : '',
          contentType: obj.contentType != null ? String(obj.contentType) : '',
          size: obj.size != null ? Number(obj.size) : undefined,
          files: obj.fileName != null ? [{
            fileName: String(obj.fileName),
            uploadedAt: obj.uploadedAt != null ? String(obj.uploadedAt) : '',
            contentType: obj.contentType != null ? String(obj.contentType) : '',
            size: obj.size != null ? Number(obj.size) : undefined,
          }] : [],
        };
      }
    }
  });
  if (srcObj) {
    Object.entries(APP_DOC_ATTACHMENT_KEY_ALIASES).forEach(([oldKey, newKey]) => {
      if (o[newKey]) return;
      const meta = normalizeAttachmentMeta(srcObj[oldKey]);
      if (meta) o[newKey] = meta;
    });
    Object.entries(srcObj).forEach(([key, value]) => {
      if (!isAddonEvidenceAttachmentKey(key)) return;
      const meta = normalizeAttachmentMeta(value);
      if (meta) o[key] = meta;
    });
  }
  return o;
};

export const attachmentLabel = (key: string) => {
  const fixed = APP_DOC_ATTACHMENT_DEFS.find((x) => x.key === key)?.label;
  if (fixed) return fixed;
  return isAddonEvidenceAttachmentKey(key) ? '加算・控除等の添付' : '添付';
};

export const evidenceKeyForAddition = (
  row: Record<string, unknown>,
  index: number,
  attachments: Record<string, AttachmentMeta | null>,
) => {
  const explicitKey = row?.evidenceKey ? String(row.evidenceKey) : '';
  if (explicitKey && attachmentFilesOf(attachments[explicitKey]).length > 0) return explicitKey;
  const indexedKey = `${ADDON_EVIDENCE_KEY_PREFIX}${index}`;
  if (attachmentFilesOf(attachments[indexedKey]).length > 0) return indexedKey;
  if (index === 0 && attachmentFilesOf(attachments[ADDON_EVIDENCE_KEY]).length > 0) return ADDON_EVIDENCE_KEY;
  return '';
};
